<template>
  <div class="home">
    <van-nav-bar
      :title="$t('EditPackage.title')"
      left-arrow
      fixed
      @click-left="$router.push('/SetMenu')"
    >
      <van-button
        slot="right"
        class="rightBtn"
        style="margin-right: 10px;"
        color="#1989fa"
        @click="patchPackage()"
      >
        {{ $t("PackageDish.save") }}
      </van-button>
    </van-nav-bar>
    <div class="contentWrapper">
      <van-cell-group>
        <van-field
          :value="tagStr"
          :label="$t('EditDish.category')"
          label-width="120"
          clearable
          :placeholder="$t('EditDish.noChoose')"
          readonly
        >
          <van-icon
            slot="right-icon"
            @click="isTagShow = true"
            size="25px"
            name="arrow"
          />
        </van-field>
        <van-field
          v-model="Package.name"
          :label="$t('EditPackage.packageName')"
          label-width="120"
          clearable
          :placeholder="$t('EditPackage.inputPackageName')"
        />
        <van-field
          v-model="Package.name_en"
          :label="$t('EditPackage.enName')"
          label-width="120"
          clearable
          :placeholder="$t('EditPackage.inputPackageName')"
        />
        <van-cell
          :title="$t('EditPackage.pic')"
          title-style="width: 120px;flex:none;"
        >
          <van-uploader :after-read="afterRead">
            <van-image
              v-if="img"
              width="55"
              fit="contain"
              height="55"
              :src="img"
            />
            <van-image
              v-else
              width="55"
              height="55"
              src="./static/img/add_img.png"
            />
          </van-uploader>
        </van-cell>
        <van-panel :title="$t('EditPackage.price')">
          <van-checkbox-group v-model="priceResult">
            <van-cell-group>
              <van-field
                v-model="Package.original_price"
                :label="$t('EditPackage.OldPrice') + currency"
                clearable
                :placeholder="$t('EditPackage.inputOldPrice')"
              >
                <van-checkbox
                  @click="togglePrice('o')"
                  :name="'o'"
                  ref="price_checkboxes"
                  slot="right-icon"
                >
                  <img
                    style="width: 20px;height: 20px"
                    slot="icon"
                    slot-scope="props"
                    :src="
                      props.checked
                        ? './static/img/sele.png'
                        : './static/img/unsele.png'
                    "
                  />
                </van-checkbox>
              </van-field>
              <van-field
                v-model="Package.special_price"
                :label="$t('EditPackage.newPrice') + currency"
                clearable
                :placeholder="$t('EditPackage.inputNewPrice')"
              >
                <van-checkbox
                  @click="togglePrice('s')"
                  :name="'s'"
                  ref="price_checkboxes"
                  slot="right-icon"
                >
                  <img
                    style="width: 20px;height: 20px"
                    slot="icon"
                    slot-scope="props"
                    :src="
                      props.checked
                        ? './static/img/sele.png'
                        : './static/img/unsele.png'
                    "
                  />
                </van-checkbox>
              </van-field>
            </van-cell-group>
          </van-checkbox-group>
        </van-panel>
      </van-cell-group>
    </div>
    <van-cell-group>
      <van-cell
        :title="$t('EditPackage.commend')"
        title-style="width: 120px;flex:none;"
      >
        <van-rate
          style="height: 23px;"
          v-model="Package.level"
          :size="20"
          gutter="10px"
          icon="./static/img/Recommend-s.png"
          void-icon="./static/img/Recommend.png"
        />
        <van-icon
          v-if="Package.level"
          slot="right-icon"
          name="./static/img/dele_staff.png"
          @click="Package.level = ''"
        />
      </van-cell>
    </van-cell-group>
    <van-field
      v-model="Package.introduction"
      type="textarea"
      autosize
      clickable
      label-width="120"
      :label="$t('EditPackage.intro')"
      :placeholder="$t('EditPackage.inputIntro')"
    />
    <van-field
      v-if="isServer"
      type="textarea"
      autosize
      clickable
      :label="$t('EditPackage.illustration')"
      :placeholder="$t('EditPackage.inputIllustration')"
    />
    <!-- 套餐标签部分 -->
    <van-cell-group class="margin_top">
      <van-cell
        :title="$t('EditPackage.addCook')"
        :label="$t('EditPackage.text')"
      >
        <div slot="right-icon">
          <van-button color="#ff6600" size="small" @click="showCopyList()">{{
            $t("ShopList.copy")
          }}</van-button>
          <van-button type="info" size="small" @click="addShow()">{{
            $t("ShopList.add")
          }}</van-button>
          <van-button
            v-if="isCheckboxesShow == 'none'"
            type="danger"
            size="small"
            @click="isCheckboxesShow = 'block'"
            >{{ $t("ShopList.delete") }}</van-button
          >
          <van-button
            v-else
            type="danger"
            size="small"
            @click="hideCheckbox()"
            >{{ $t("PackageDish.cancel") }}</van-button
          >
        </div>
      </van-cell>
    </van-cell-group>
    <div class="header">
      <div class="leftbox mleft">
        <span>{{ $t("SetMenu.show") }}</span>
        <span class="mleft">{{ $t("SetMenu.name") }}</span>
      </div>
      <div class="rightbox">
        <span class="swtichName">{{ $t("SetMenu.perferSwitch") }}</span>
        <span class="edit">{{ $t("SetMenu.edit") }}</span>
      </div>
    </div>
    <van-checkbox-group v-model="tagResult" v-if="tags">
      <draggable
        v-model="tags"
        handle=".dragIcon"
        chosen-class="chosen"
        force-fallback="true"
        group="people"
        @start.stop="onStart"
        @end.stop="onEnd"
        :move="onMove"
      >
        <van-field
          v-for="(pack, index) in tags"
          :key="pack.id"
          :readonly="isCheckboxesShow == 'none' ? false : true"
          @click="isCheckboxesShow == 'none' ? '' : tagToggle(index)"
          @focus="isCheckboxesShow == 'none' ? showPackBtn(index) : ''"
          @blur="
            isCheckboxesShow == 'none' ? hidePackBtn(index) : '';
            handlePackageTag(index);
          "
          v-model="pack.name"
          :placeholder="$t('EditPackage.inputCategory')"
        >
          <van-checkbox
            v-if="isCheckboxesShow != 'none'"
            :style="{ display: isCheckboxesShow }"
            class="top"
            :name="pack.id"
            ref="sort_checkboxes"
            slot="left-icon"
          >
            <img
              style="width: 20px;height: 20px"
              slot="icon"
              slot-scope="props"
              :src="
                props.checked
                  ? './static/img/sele.png'
                  : './static/img/unsele.png'
              "
            />
          </van-checkbox>
          <van-icon
            v-else
            name="./static/img/drag.png"
            class="dragIcon"
            slot="left-icon"
          />
          <template slot="right-icon">
            <div class="tagSort">
              <!-- 是否多选开关 -->
              <van-switch
                v-model="pack.is_choiced"
                size="18px"
                @change="changeSetChoiced(pack.is_choiced, index)"
                active-color="#2f75f7"
                inactive-color="#ee0a24"
                :active-value="1"
                :inactive-value="0"
              />
              <van-button
                type="info"
                size="small"
                @click="toPackageDish(pack.id, pack.menu_id)"
                >{{ $t("ShopList.edit") }}</van-button
              >
            </div>
          </template>
        </van-field>
      </draggable>
    </van-checkbox-group>
    <div style="height: 60px;width: 100%;background: #F3F5F7"></div>
    <!-- 触发全选删除 -->
    <van-tabbar v-if="isCheckboxesShow == 'block'">
      <div style="width: 100%;height: 50px;">
        <div class="bottomBtn fl">
          <van-icon
            size="30px"
            @click="selectAll()"
            name="./static/img/all.png"
          />
        </div>
        <div class="bottomBtn fr">
          <van-icon
            size="30px"
            @click="delTag()"
            name="./static/img/Trash_s.png"
          />
        </div>
      </div>
    </van-tabbar>
    <!-- 分类 -->
    <van-popup v-model="isTagShow" position="bottom" :style="{ height: '70%' }">
      <van-cell-group>
        <van-cell title="">
          <van-icon
            slot="icon"
            name="./static/img/dele_staff.png"
            size="25px"
            @click="isTagShow = false"
          />
          <van-icon
            slot="right-icon"
            name="./static/img/ok1.png"
            size="25px"
            @click="TagShow"
          />
        </van-cell>
        <p style="text-align: center;padding: 5px 0;margin:0;">
          {{ $t("EditDish.noChoose1") }}
        </p>
        <van-checkbox-group v-model="p_tagResult">
          <van-cell-group>
            <van-cell
              v-for="(tag, index) in p_tags"
              clickable
              :key="index"
              :title="tag.name"
              v-show="tag.name !== null"
              @click="togglePerfer(index)"
            >
              <van-checkbox :name="tag.id" ref="perferboxes" slot="right-icon">
                <img
                  style="width: 20px;height: 20px"
                  slot="icon"
                  slot-scope="props"
                  :src="
                    props.checked
                      ? './static/img/sele.png'
                      : './static/img/unsele.png'
                  "
                />
              </van-checkbox>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </van-cell-group>
    </van-popup>
    <van-popup
      v-model="isCopyListShow"
      position="bottom"
      :style="{ height: '70%' }"
    >
      <van-cell-group>
        <van-cell title="">
          <van-icon
            slot="icon"
            name="./static/img/dele_staff.png"
            size="25px"
            @click="isCopyListShow = false"
          />
          <van-icon
            slot="right-icon"
            name="./static/img/ok1.png"
            size="25px"
            @click="copyTag()"
          />
        </van-cell>
        <van-radio-group v-model="copyResult">
          <van-cell-group>
            <van-cell
              clickable
              v-for="(tag, index) in tagList"
              v-show="tag.name !== null"
              :key="index"
              :title="tag.name"
              @click="selTag(tag.id)"
            >
              <van-radio :name="tag.id" slot="right-icon">
                <img
                  style="width: 20px;height: 20px"
                  slot="icon"
                  slot-scope="props"
                  :src="
                    props.checked
                      ? './static/img/sele.png'
                      : './static/img/unsele.png'
                  "
                />
              </van-radio>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  data() {
    return {
      Package: {
        name: "",
        name_en: "",
        image_id: "",
        level: 0,
        store_id: sessionStorage.actShopId,
        original_price: "",
        special_price: "",
        type: "o",
        introduction: "",
        class_id: ""
      },
      img: "",
      priceResult: [],

      isAddTagShow: false,
      tags: [],
      shopTags: [],
      tagResult: [],
      result: [],
      isCheckboxesShow: "none",
      isSortShow: false,
      sorts: [],
      tagStr: "",

      actPackBtn: -1,
      isServer: false,
      currency: "",
      tagList: [],
      isCopyListShow: false,
      copyResult: "",

      isTagShow: false,
      p_tagResult: [],
      p_tags: []
    };
  },
  mounted: function() {
    this.getTags();
    this.getTagList();
    this.getPackage();
    this.getCurrency();
  },
  methods: {
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append("type", "shop");
      formData.append("file", file.file);
      this.$axios({
        method: "post",
        url: this.$build + "/api/image",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + sessionStorage.token
        },
        data: formData
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.Package.image_id = res.data.success.image_id;
            this.img = res.data.success.url;
            // this.$toast({
            //   type: "success",
            //   message: res.data.message
            // });
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditPackage.message")
          });
        });
    },
    getPackage() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/" + this.$route.params.id + "/index"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.Package = res.data.data;
            this.tags = res.data.data.tags.data;
            if (res.data.data.image) {
              this.img = res.data.data.image.path;
              this.Package.image_id = res.data.data.image.id;
            }
            // 插入原有标签
            this.p_tagResult = res.data.data.class_id;
            console.log(res.data.data.class_id);
            this.TagShow();
            //页面刷新时，默认显示原价
            // this.priceResult[0]=res.data.data.type;
            this.$set(this.priceResult, 0, res.data.data.type);

            this.sorts = [];
            for (let i = 0; i < res.data.data.tags.data.length; i++) {
              var obj = {};
              obj.id = res.data.data.tags.data[i].id;
              obj.order_number = i + 1;
              this.sorts.push(obj);
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditPackage.message")
          });
        });
    },
    getTags() {
      // 获取套餐自定义标签
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build +
          "/api/tags/" +
          sessionStorage.actShopId +
          "/index/0/class"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.p_tags = res.data.data;
            console.log(this.p_tags);
            this.TagShow();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    TagShow() {
      this.isTagShow = false;
      this.tagStr = "";
      for (let i = 0; i < this.p_tags.length; i++) {
        for (let j = 0; j < this.p_tagResult.length; j++) {
          if (this.p_tagResult[j] == this.p_tags[i].id) {
            this.tagStr += this.p_tags[i].name + ",";
          }
        }
      }
      // sessionStorage.setItem('tagStr',this.tagStr)
    },
    togglePerfer(index) {
      this.$refs.perferboxes[index].toggle();
    },
    // 保存套餐
    patchPackage() {
      if (this.Package.name) {
        this.Package.ids = JSON.stringify(this.p_tagResult);
        var data = {};
        data.name = this.Package.name;
        data.name_en = this.Package.name_en;
        data.image_id = this.Package.image_id;
        data.level = this.Package.level;
        data.store_id = this.Package.store_id;
        data.original_price = this.Package.original_price;
        data.special_price = this.Package.special_price;
        data.type = this.Package.type;
        data.introduction = this.Package.introduction;
        data.ids = JSON.stringify(this.p_tagResult);
        this.$axios({
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url: this.$build + "/api/menu/" + this.$route.params.id + "/update",
          data: data
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              //保存套餐后跳转
              // const vm=this;
              // setTimeout(function(){
              // 	vm.$router.push('/SetMenu');
              // },1000);
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("EditPackage.message")
            });
          });
      } else {
        this.$toast(this.$t("EditPackage.pleaseInputName"));
      }
    },
    togglePrice(val) {
      this.priceResult = [];
      this.priceResult.push(val);
      this.Package.type = this.priceResult[0];
    },
    // 添加标签
    addShow() {
      //if(this.newPerfer.name){
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/" + this.$route.params.id + "/addTags"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            this.getPackage();
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditPackage.message")
          });
        });
      //}else{
      //this.$toast('请填写完整信息');
      //}
    },
    showPackBtn(index) {
      this.actPackBtn = index;
    },
    hidePackBtn(index) {
      const vm = this;
      setTimeout(function() {
        if (index == vm.actPackBtn || index == -1) {
          vm.actPackBtn = -1;
        }
      }, 60);
    },
    // 修改标签
    patchPackageTag(index) {
      this.hidePackBtn(-1);
      console.log(
        this.tags[index].name +
          "   " +
          this.tags[index].id +
          "   " +
          this.tags[index].is_choiced
      );
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/" + this.$route.params.id + "/editTags",
        data: {
          name: this.tags[index].name,
          tags_id: this.tags[index].id,
          is_choiced:
            this.tags[index].is_choiced == undefined
              ? 0
              : this.tags[index].is_choiced
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });

            // const vm=this;
            // setTimeout(function(){
            // 	vm.$router.push('/PackageTags/'+res.data.data.id);
            // },1000);
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditPackage.message")
          });
        });
    },
    // 删除分类
    delTag() {
      if (this.tagResult.length > 0) {
        this.$dialog
          .confirm({
            title: this.$t("EditPackage.delCategory"),
            message: this.$t("EditPackage.isDelCategory"),
            confirmButtonColor: "#2f75f4",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "DELETE",
              headers: {
                Authorization: "Bearer " + sessionStorage.token
              },
              url:
                this.$build + "/api/menu/" + this.$route.params.id + "/subTags",
              data: {
                ids: JSON.stringify(this.tagResult)
              }
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  this.$toast({
                    type: "success",
                    message: res.data.message
                  });
                  this.tagResult = [];
                  this.hideCheckbox();
                  this.getPackage();
                } else {
                  for (var item in res.data.error) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("EditPackage.message")
                });
              });
          })
          .catch(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("EditPackage.chooseDelLabel")
        });
      }
    },
    hideCheckbox() {
      this.isCheckboxesShow = "none";
      this.isSortShow = false;
    },
    selectAll() {
      if (this.tagResult.length != this.tags.length) {
        this.tagResult = [];
        for (var i = this.tags.length - 1; i >= 0; i--) {
          this.tagResult.push(this.tags[i].id);
        }
      } else {
        this.tagResult = [];
      }
    },
    toggle(index) {
      if (this.result.length >= 1) {
        this.result = [];
      }
      this.$refs.checkboxes[index].toggle();
    },
    tagToggle(index) {
      if (this.isSortShow) {
        this.tagResult = [];
        this.$refs.sort_checkboxes[index].toggle();
      } else {
        this.$refs.tag_checkboxes[index].toggle();
      }
    },
    toPackageDish(pack_id, menu_id) {
      // if(this.timer){
      // 	clearTimeout(this.timer)
      // }
      this.timer = setTimeout(() => {
        sessionStorage.setItem("actPackageTagId", menu_id);
        this.$router.push("/PackageDish/" + pack_id);
      }, 800);
    },
    //保存分类
    handlePackageTag(index) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.patchPackageTag(index);
      }, 200);
    },
    // 获取店铺设置的货币
    getCurrency() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build + "/api/store/" + sessionStorage.actShopId + "/currency"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.currency = res.data.data.unit;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    // 获取店铺设置的标签
    getTagList() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build + "/api/store/" + sessionStorage.actShopId + "/menuTags"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.tagList = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    copyTag() {
      if (this.copyResult) {
        this.$axios({
          method: "post",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url:
            this.$build +
            "/api/menu/" +
            this.$route.params.id +
            "/selectMenuTag",
          data: {
            id: this.copyResult
          }
        })
          .then(res => {
            if (res.data.status == 200) {
              this.isCopyListShow = false;
              this.getPackage();
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("EditDish.message")
            });
          });
      }
    },
    showCopyList() {
      this.isCopyListShow = true;
    },
    selTag(id) {
      this.copyResult = id;
    },
    changeSetChoiced(val, index) {
      console.log(val, index);
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.patchPackageTag(index);
      }, 200);
      // console.log(this.tags[index].is_choiced);
      // console.log(this.tags);
    },
    // 拖拽排序
    onStart(e) {
      this.drag = true;
      console.log(e, "开始");
    },
    onEnd(e) {
      this.disabled = true;
      this.data = {
        pivot_id: this.startItem.id,
        pivot_ids: this.endItem.id
      };
      this.sort();
    },
    onMove(e, originalEvent) {
      //拖拽位置
      this.startItem = e.draggedContext.element;
      //停靠位置
      this.endItem = e.relatedContext.element;
      if (e.draggedContext.element) return false;
    },
    sort() {
      this.$toast.loading({
        message: "loading...",
        forbidClick: true
      });
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/" + this.$route.params.id + "/tagsUpDown",
        data: this.data
      })
        .then(res => {
          console.log(res);
          this.data = null;
          if (res.data.status == 200) {
            this.getPackage();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast.clear();
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field__left-icon .van-icon {
  font-size: 20px;
}
/deep/ .van-cell .van-icon {
  font-size: 20px;
}
/deep/ .van-cell__title {
  width: 120px;
}
/deep/ .van-action-sheet__name {
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  /*设置内容不换行*/
  text-overflow: ellipsis;
  /*设置文字超出文本框的内容显示成...*/
  overflow: hidden;
  /*设置超出隐藏*/
}
/deep/ .van-cell__title > span {
  display: block;
  white-space: nowrap;
  /*设置内容不换行*/
  text-overflow: ellipsis;
  /*设置文字超出文本框的内容显示成...*/
  overflow: hidden;
  /*设置超出隐藏*/
}
/deep/ .van-field__control {
  margin-left: 0.9375rem;
}
/* 顶部栏固定 */
.contentWrapper {
  /* padding-top: 46px; */
}
.home {
  width: 100%;
  /*height: 100vh;*/
}
.bn {
  border: none;
}
.margin_top {
  margin-top: 3px;
}
.Bottom {
  position: absolute;
  bottom: 0;
  height: 60px;
  background: #fff;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cancelBtn {
  width: 30%;
  top: 10%;
  left: 5%;
  background: #dfdede;
  font-weight: bold;
  font-size: 16px;
}
.certainBtn {
  width: 30%;
  top: 10%;
  right: 5%;
  background: linear-gradient(90deg, #ffc914, #ffb20d);
  font-weight: bold;
  font-size: 16px;
}
.van-cell__value {
  text-align: left;
}
.dragIcon {
  z-index: 999;
  position: relative;
  top: 20%;
  cursor: move;
}
.top {
  position: relative;
  top: 20%;
}
.editBtn {
  position: absolute;
  right: 0px;
  top: 0px;
}
.tagInput {
  font-size: 14px;
  text-indent: 10px;
  width: 90%;
  height: 33px;
  line-height: 33px;
  border: 1px solid #ffb20d;
  margin-left: 5%;
  border-radius: 5px;
}
.bottomBtn {
  width: 30px;
  height: 30px;
  margin: 10px 20px;
}
.sortBtn {
  width: 25%;
  height: 30px;
  margin: 10px 0px;
  text-align: center;
  float: left;
}
.tagSort {
  width: 7.5rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.header div {
  display: inline-block;
}
.header {
  padding: 0.625rem 0rem 0.3125rem;
  background: #fff;
}
.mleft {
  margin-left: 10px;
}
.rightbox {
  float: right;
}
.swtichName {
  display: inline-block;
  width: 3.4375rem;
}
.edit {
  display: inline-block;
  width: 4.0625rem;
}
</style>



// WEBPACK FOOTER //
// src/Shop/EditPackage.vue